import { Wrapper } from './styles';

const Hero = ({ children }) => <Wrapper>{children}</Wrapper>;

export default Hero;
